import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import {
  Grid,
  Row,
  Col,
  Navbar,
  FormGroup,
  FormControl,
  InputGroup,
} from 'react-bootstrap';

import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as OperatorsActions from './redux/OperatorsActions';

class OperatorsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
    };
  }

  componentWillMount() {
    this.props.find({
      order: 'name ASC',
    });
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  render() {
    let _this = this;
    let { history, Operators } = this.props;
    return (
      <div className="main-content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    {'Lista de Operadores'}{' '}
                    <div className="pull-right header-table">
                      <Button
                        bsStyle="primary"
                        wd
                        onClick={() =>
                          history.push('/admin/config/operators/create')
                        }
                      >
                        Agregar Operador
                      </Button>
                      <Navbar.Form pullLeft className="navbar-search-form">
                        <FormGroup>
                          <InputGroup>
                            <InputGroup.Addon>
                              <i className="fa fa-search" />
                            </InputGroup.Addon>
                            <FormControl
                              type="text"
                              placeholder="Buscar..."
                              value={Operators.search}
                              onChange={this.search.bind(this)}
                            />
                          </InputGroup>
                        </FormGroup>
                      </Navbar.Form>
                    </div>
                    <div className="clearfix" />
                  </div>
                }
                ctFullWidth
                content={
                  <ReactTable
                    data={
                      Operators.searchData
                        ? Operators.searchData
                        : Operators.data
                    }
                    page={Operators.table.page}
                    sorted={Operators.table.sorted}
                    filtered={Operators.table.filtered}
                    pageSize={Operators.table.pageSize}
                    onSortedChange={(change) =>
                      _this.props.changeTable('sorted', change)
                    }
                    onFilteredChange={(change) =>
                      _this.props.changeTable('filtered', change)
                    }
                    onPageChange={(change) =>
                      _this.props.changeTable('page', change)
                    }
                    onPageSizeChange={(change) =>
                      _this.props.changeTable('pageSize', change)
                    }
                    previousText={'Anterior'}
                    nextText={'Siguiente'}
                    loadingText={'Cargando...'}
                    noDataText={'No se encontraron registros'}
                    pageText={'Página'}
                    ofText={'de'}
                    rowsText={'filas'}
                    columns={[
                      {
                        Header: 'Nombre',
                        accessor: 'name',
                        minWidth: 120,
                      },
                      {
                        Header: 'Sitio web',
                        accessor: 'website',
                      },
                      {
                        Header: 'Teléfono',
                        accessor: 'phone',
                      },
                      {
                        Header: 'Acciones',
                        accessor: 'actions',
                        sortable: false,
                        filterable: false,
                        Cell: (props) => (
                          // we've added some custom button actions
                          <div className="actions-right">
                            {/* use this button to add a edit kind of action */}
                            <Button
                              onClick={() =>
                                history.push(
                                  '/admin/config/operators/' + props.original.id
                                )
                              }
                              bsStyle="warning"
                              simple
                            >
                              Editar
                            </Button>{' '}
                          </div>
                        ),
                      },
                    ]}
                    className="-striped -highlight"
                  />
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Operators: state.Operators,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(OperatorsActions, dispatch);
};

const OperatorsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(OperatorsIndex);

export default OperatorsConnect;



// WEBPACK FOOTER //
// ./src/views/Operators/OperatorsIndex.jsx